import { UarmRecordSend, UarmArm, UarmRecordField, CardMetaItem } from './types';

export class UarmListTreeLevel {
	private static logPad = '    ';
	//
	//
	//     TREE_LEVEL
	//
	//
	/** Уровень дерева, который грузится в АРМ, для которого нет записи в sessionStorage */
	static defaultTreeLevel = 1;
	/** Получение ключа, с которым в сессию сохраняется уровень дерева */
	private static getLevelKey(currentArmId: number): string {
		if (!currentArmId) console.error(this.logPad + 'UarmListTreeLevel.getLevelKey: armId not set');
		const prefix = 'UarmListTreeLevel.getLevelKey';
		return `${prefix}::${currentArmId}`;
	}
	private static getLevelValue(currentArmId: number): number | null {
		const memKey = this.getLevelKey(currentArmId);
		const memValue = window.sessionStorage.getItem(memKey);
		console.log(this.logPad + `UarmListTreeLevel.getLevelValue (armId=${currentArmId}). memValue=`, memValue);
		if (memValue === null) return null;
		return Number(memValue);
	}
	static getLevelValueWithDef(currentArmId: number): number {
		return this.getLevelValue(currentArmId) || this.defaultTreeLevel;
	}
	/**
	 * Saves the tree level for the given armId into sessionStorage.
	 * If treeLevel is -1, it is replaced with the current tree level + 1.
	 * @param {number} currentArmId - the armId which tree level is saved
	 * @param {number} treeLevel - the tree level to save
	 */

	static setLevelValue(currentArmId: number, treeLevel: number): void {
		// спец костыль: увеличиваем текущее значение
		if (treeLevel === -1) {
			console.log(this.logPad + `Инкрементируем текущее значение (${UarmListTreeLevel.getLevelValueWithDef(currentArmId)}) на +1`);
			treeLevel = UarmListTreeLevel.getLevelValueWithDef(currentArmId) + 1;
		}
		const memKey = this.getLevelKey(currentArmId);
		const memValue = treeLevel;
		console.log(this.logPad + `UarmListTreeLevel.setLevelValue (armId=${currentArmId}). memValue=`, memValue);
		if (memValue) {
			window.sessionStorage.setItem(memKey, JSON.stringify(memValue));
		}
	}
	//
	//
	//     ID_PATH
	//
	//
	/** Получение ключа, с которым в сессию сохраняется ID_PATH последней записи для раскрытия дерева при возврате из списка */
	private static getIdPathKey(currentArmId: number): string {
		if (!currentArmId) console.error(this.logPad + 'UarmListTreeLevel.getRecordIdPathKey: armId not set');
		const prefix = 'UarmListTreeLevel.getIdPathKey';
		return `${prefix}::${currentArmId}`;
	}

	static getIdPathValue(currentArmId: number): string | null {
		const memKey = this.getIdPathKey(currentArmId);
		const memValue = window.sessionStorage.getItem(memKey);
		if (memValue === null) return null;
		console.log(this.logPad + `UarmListTreeLevel.getIdPathValue (armId=${currentArmId}). memValue=`, memValue);
		return memValue;
	}

	static setIdPathValue(currentArmId: number, idPath: string): void {
		const memKey = this.getIdPathKey(currentArmId);
		const memValue = idPath;
		console.log(this.logPad + `UarmListTreeLevel.setIdPathValue (armId=${currentArmId}). memValue=`, memValue);
		if (memValue) {
			window.sessionStorage.setItem(memKey, memValue);
		}
	}

	private static logInner = (method, ...args) => {
		console[method](...args);
	}
	static console = {
		warn: UarmListTreeLevel.logInner.bind(null, 'warn'),
		error: UarmListTreeLevel.logInner.bind(null, 'error'),
		log: UarmListTreeLevel.logInner.bind(null, 'log'),
	}
}
